import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { GravatarModule } from 'ngx-gravatar';
import { map } from 'rxjs';

import { AuthRoutes } from '@bn/auth';
import { AuthService } from '@bn/auth/services';
import { MainMenuComponent } from '@bn/layout';

import { CustomerRoutes } from '../../core/enums/customer-routes.enum';
import { PartnerStore } from '../../core/stores';
import { PartnerCustomerStore } from '../../pages/customer/stores';

import { mainMenuChildRoutes, mainMenuConfig } from './main-menu.config';

@Component({
  selector: 'bn-partner-portal-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [RouterLink, FaIconComponent, MainMenuComponent, GravatarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  public readonly isMobileMenuOpened = input(false, { transform: booleanAttribute });

  public readonly toggleMenu = output<boolean>();

  public readonly menuConfig = mainMenuConfig;
  public readonly childRoutes = mainMenuChildRoutes;
  public readonly isUserMenuOpen = signal(false);

  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly customerStore = inject(PartnerCustomerStore);
  private readonly partnerStore = inject(PartnerStore);

  public readonly userEmail = toSignal(this.authService.getAuthStore().pipe(map((s) => s?.user?.Email ?? null)), { initialValue: null as string | null });

  public onAddCustomer(): void {
    this.router.navigate(['/', CustomerRoutes.AddCustomer]);
  }

  public onCloseMobileMenu(): void {
    this.toggleMenu.emit(false);
  }

  public toggleUserMenu(): void {
    this.isUserMenuOpen.update((open) => !open);
  }

  public onLogout(): void {
    this.isUserMenuOpen.set(false);
    this.customerStore.reset();
    this.partnerStore.reset();
    this.authService.logout();
    this.router.navigate(['/', AuthRoutes.Auth, AuthRoutes.Login]);
  }
}
